import { BreakPoints, LibroTheme, MaterialStyleMap } from '../../types';

export default (theme: LibroTheme): MaterialStyleMap => ({
  MuiTab: {
    styleOverrides: {
      labelIcon: {
        '& $wrapper :first-of-type': {
          fontSize: 14,
          marginBottom: 0,
          marginRight: 6,
        },
        minHeight: undefined,
        paddingTop: undefined,
      },
      root: {
        textTransform: 'none',
        padding: '1.2rem',
        [theme.breakpoints.up(BreakPoints.Small)]: {
          minWidth: null,
        },
      },
      wrapper: {
        flexDirection: 'row',
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      scrollButtons: {
        width: 'auto',
      },
    },
  },
});
